"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Package, TrendingUp, Shield, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function SupplierPortal() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const benefits = [{
    icon: Package,
    title: "Streamlined Order Management",
    description: "Track shipments and manage inventory in real-time"
  }, {
    icon: TrendingUp,
    title: "Performance Analytics",
    description: "Gain insights into delivery metrics and efficiency"
  }, {
    icon: Shield,
    title: "Secure Transactions",
    description: "End-to-end encrypted communication and payments"
  }, {
    icon: Clock,
    title: "24/7 Access",
    description: "Manage your operations anytime, anywhere"
  }];
  return <section id="supplier-portal" className="relative min-h-screen bg-background">
      <div className="grid lg:grid-cols-2 min-h-screen">
        {}
        <div className="relative h-[50vh] lg:h-screen overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out scale-105 hover:scale-110" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/logistics_hub_modern.png)"
        }}>
            <div className="absolute inset-0 bg-primary/20"></div>
          </div>
        </div>

        {}
        <div className="flex items-center justify-center px-6 py-16 lg:px-16 xl:px-24">
          <div className="w-full max-w-2xl space-y-12">
            {}
            <div ref={headlineRef} className={`space-y-6 transition-all duration-500 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h1 className="font-display text-4xl md:text-5xl xl:text-6xl font-bold text-foreground leading-tight">
                Supplier Portal
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Experience a premium, uncluttered platform designed for seamless
                collaboration and efficiency. Manage your supply chain operations
                with confidence.
              </p>
            </div>

            {}
            <div ref={listRef} className="space-y-6">
              {benefits.map((benefit, i) => {
              const Icon = benefit.icon;
              return <div key={i} data-index={i} className={`group flex items-start gap-4 transition-all duration-300 ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
                transitionDelay: listVisible ? `${i * 100}ms` : "0ms"
              }}>
                    <div className="flex-shrink-0 w-12 h-12 rounded-sm bg-primary-light flex items-center justify-center border border-primary/10 transition-all duration-300 group-hover:bg-accent group-hover:shadow-[0_0_20px_rgba(186,186,85,0.4)] group-hover:border-accent">
                      <Icon className="w-5 h-5 text-primary transition-colors duration-300 group-hover:text-white" strokeWidth={1} />
                    </div>
                    <div className="flex-1 pt-1">
                      <h3 className="font-display font-semibold text-lg text-foreground mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {}
            <div className={`transition-all duration-500 delay-500 ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Link to="#" className="btn-primary inline-flex">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}